import React from 'react'
import { Component } from 'reflux'
import { ColorCategoryActions, ColorCategoryStore, STATUS } from 'Stores/colorCategoryStore'
import { Button, Form, Input, Row, Col, Label } from 'reactstrap'
import _ from 'lodash'
import CollapsibleCard from 'Components/collapsibleCard'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fragment } from 'react'

export default class ColorCategoryForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [ColorCategoryStore]
    this.storeKeys = ['status', 'colorCategoryDetails']
  }

  resetColorCategory = () => {
    if (_.get(this.props, 'match.params.ColorCategoryID')) {
      ColorCategoryActions.getColorCategoryDetails(this.props.match.params.ColorCategoryID)
    } else {
      ColorCategoryActions.createEmptyColorCategory()
    }
  }

  render() {
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/color-categories' />
    }

    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }

    return (
      <>
        <CollapsibleCard startOpen header={<strong>{_.get(this.props, 'match.params.ColorCategoryID') ? 'Detaljer' : 'Opret'}</strong>}>
          <Form>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='name'>Navn</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.colorCategoryDetails.name}
                  name='name'
                  id='name'
                  onChange={ColorCategoryActions.updateColorCategoryField}
                  invalid={!this.state.colorCategoryDetails.name.length}
                />
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='hexCode'>Color</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='color'
                  value={this.state.colorCategoryDetails.hexCode}
                  name='hexCode'
                  id='hexCode'
                  onChange={ColorCategoryActions.updateColorCategoryField}
                  invalid={!this.state.colorCategoryDetails.hexCode.length}
                />
              </Col>
            </Row>
            <Button
              onClick={ColorCategoryActions.saveColorCategory}
              disabled={this.state.status === STATUS.IS_SAVING || !this.state.colorCategoryDetails.name.length}
            >
              {this.state.status === STATUS.IS_SAVING ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
            </Button>
            <Button color='danger' onClick={this.resetColorCategory} className='ml-2'>
              Nulstil
            </Button>
          </Form>
        </CollapsibleCard>
      </>
    )
  }
}
